
import { defineComponent } from "vue";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import VueElementLoading from "vue-element-loading";
import consts from "@/const/const";
const gakumonRepository = RepositoryFactory.getQuery("gakumon");

// URLを取得
const getParameters = location.search;

function import_script(urls: string[]) {
  return Promise.all(
    urls.map(function (url: string) {
      return new Promise(function (resolve) {
        const script = document.createElement("script");
        script.src = url;
        script.onload = resolve;
        document.head.appendChild(script);
      });
    })
  );
}

export default defineComponent({
  name: "Gakumon",
  components: {
    VueElementLoading,
  },
  data() {
    return {
      posts: [],
      classFlag: "",
      searchCode: "" as string | null,
      gakumonBunya: "" as string | null,
      consts: consts,
      loadingshow: false,
    };
  },
  created() {
    this.initFetch();
  },
  mounted() {
    import_script(["./js/gatag.js"]);

    // 学問系統によってクラスを変更する
    let searchParams = new URLSearchParams(location.search);
    this.searchCode = searchParams?.get("cd");
    let searchNumber = Number(this.searchCode?.slice(-3));
    if (searchNumber >= 470) {
      this.classFlag = "4";
    } else if (searchNumber >= 220) {
      this.classFlag = "3";
    } else if (searchNumber >= 110) {
      this.classFlag = "2";
    } else {
      this.classFlag = "1";
    }

    // 学問分野
    this.gakumonBunya = this.getParameterByName("cd");
  },
  methods: {
    async initFetch() {
      if (getParameters) {
        this.loadingshow = true;
        let gakumondata: any;
        try {
          const { data } = await gakumonRepository.getQuery(getParameters);
          gakumondata = data;
        } catch (err) {
          this.loadingshow = false;
          alert("データの取得に失敗しました。");
          return false;
        }
        this.posts = gakumondata;
      }
      this.loadingshow = false;
    },
    /**
     * Get the URL parameter value
     *
     * @param  name {string} パラメータのキー文字列
     * @return url {string} 対象のURL文字列
     */
    getParameterByName(name: string, url = window.location.href) {
      name = name.replace(/[[]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
  },
});
